import React from 'react';
import { LogisticsObjectFormDialog } from '@/components/common/LogisticsObjectFormDialog';
import { defaultQuotationTemplate } from '@/utils/quotationDefaultTemplate';
import { ACLAuthorizationRequest } from '@/api/bol';

export interface QuotationFormDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: { memberIdentifier: string; quotationJson: string; aclAuthorizations?: ACLAuthorizationRequest[] }) => Promise<void>;
}

export const QuotationFormDialog: React.FC<QuotationFormDialogProps> = ({
  open,
  onClose,
  onSubmit,
}) => {
  const handleSubmit = async (data: { memberIdentifier: string; jsonData: string; quotationJson?: string; aclAuthorizations?: ACLAuthorizationRequest[] }) => {
    // Transform the generic jsonData back to the expected quotationJson field
    const transformedData = {
      memberIdentifier: data.memberIdentifier,
      quotationJson: data.quotationJson || data.jsonData,
      aclAuthorizations: data.aclAuthorizations
    };
    await onSubmit(transformedData);
  };

  return (
    <LogisticsObjectFormDialog
      open={open}
      onClose={onClose}
      onSubmit={handleSubmit}
      title="Create New Quotation"
      jsonFieldName="quotationJson"
      defaultJsonTemplate={defaultQuotationTemplate()}
      jsonLabel="Enter a valid Quotation JSON according to the SDL schema:"
      jsonHelperText="The JSON must conform to the Quotation schema defined in the BOL API"
      submitButtonText="Create"
    />
  );
};